import { Machine } from 'xstate';
import { assign } from '@xstate/immer';

import { LayoutStyle } from '~/api/models/leadads/context-card';

interface ContextCardSchema {
  states: {
    initializing: {};
    disabled: {};
    select: {};
    create: {};
    createFirst: {};
  };
}

export type ContextCardForm = {
  headline: string;
  paragraph: string;
  list: string[];
  layout: LayoutStyle;
  image: null | string;
};

interface ContextCardContext {
  defaultCard: string;
  selectedCard: string | null;
}

type ContextCardEvent =
  | { type: 'CONTEXT_CARDS.noData' }
  | { type: 'CONTEXT_CARDS.select'; cardId: string }
  | { type: 'CONTEXT_CARDS.toggleEnabled' }
  | { type: 'CONTEXT_CARDS.toggleModes' };

const contextCardsMachine = Machine<ContextCardContext, ContextCardSchema, ContextCardEvent>({
  id: 'lead-ad-context-cards',
  initial: 'initializing',
  states: {
    initializing: {
      on: {
        'CONTEXT_CARDS.select': {
          target: 'select',
          actions: [
            assign((ctx, evt) => {
              ctx.selectedCard = evt.cardId;
              ctx.defaultCard = evt.cardId;
            }),
            'onCardSelected',
          ],
        },
        'CONTEXT_CARDS.noData': 'createFirst',
      },
    },
    select: {
      entry: 'onReady',
      on: {
        'CONTEXT_CARDS.select': {
          actions: [
            assign((ctx, evt) => { ctx.selectedCard = evt.cardId; }),
            'onCardSelected',
          ],
        },
        'CONTEXT_CARDS.toggleEnabled': {
          target: 'disabled',
          actions: assign((ctx) => { ctx.selectedCard = null; }),
        },
        'CONTEXT_CARDS.toggleModes': 'create',
      },
    },
    disabled: {
      entry: 'onReady',
      on: {
        'CONTEXT_CARDS.toggleEnabled': [
          { target: 'createFirst', cond: (ctx) => !ctx.defaultCard },
          {
            target: 'select',
            actions: [
              assign((ctx) => { ctx.selectedCard = ctx.defaultCard; }),
              'onCardSelected',
            ],
          },
        ],
      },
    },
    createFirst: {
      entry: 'onNotReady',
      on: {
        'CONTEXT_CARDS.toggleEnabled': 'disabled',
        'CONTEXT_CARDS.select': {
          target: 'select',
          actions: assign((ctx, evt) => {
            ctx.selectedCard = evt.cardId;
            ctx.defaultCard = evt.cardId;
          }),
        },
      },
    },
    create: {
      entry: 'onNotReady',
      on: {
        'CONTEXT_CARDS.toggleEnabled': {
          target: 'disabled',
          actions: assign((ctx) => { ctx.selectedCard = null; }),
        },
        'CONTEXT_CARDS.toggleModes': 'select',
        'CONTEXT_CARDS.select': {
          target: 'select',
          actions: assign((ctx, evt) => {
            ctx.selectedCard = evt.cardId;
          }),
        },
      },
    },
  },
});

export default contextCardsMachine;
